

















































import Vue from 'vue';
import { SidebarMenu } from 'vue-sidebar-menu';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';
import { mapActions, mapGetters } from 'vuex';
import {
    SidebarItem,
    SidebarComponentItem,
    SidebarHeaderItem
} from 'vue-sidebar-menu';

import Copyright from '@/components/Common/Copyright.vue';

export default Vue.extend({
    name: 'Sidebar',
    components: {
        SidebarMenu,
        Copyright,
    },
    props: {
        /** Возвращает ширину сайдбара для вышестоящих компонентов */
        modelValue: {
            type: String,
            required: true,
        },
    },
    model: {
        prop: 'modelValue',
        event: 'input',
    },
    mounted() {
        this.loadMenu();
        this.$emit('input', this.sidebarOffsetWidth);
    },
    computed: {
        ...mapGetters('sidebar', {
            menu: 'getMenu',
            menuAdmin: 'getAdminMenu',
            isOpen: 'getIsOpen',
            sidebarWidth: 'getWidth',
            sidebarWidthCollapsed: 'getWidthCollapsed'
        }),
        ...mapGetters('app', {
            appName: 'getAppName',
        }),
        ...mapGetters('auth', {
            adminMode: 'isAdmin',
        }),
        isSidebarCollapsed(): boolean {
            return !(this.isOpen as boolean);
        },
        sidebarOffsetWidth(): string {
            // расчет отступа бокового меню
            let resultWidth = '350px';
            if (this.isSidebarCollapsed) {
                resultWidth =
                    this.sidebarWidthCollapsed === undefined
                        ? '50px'
                        : this.sidebarWidthCollapsed;
            } else {
                resultWidth =
                    this.sidebarWidth === undefined
                        ? '350px'
                        : this.sidebarWidth;
            }
            return resultWidth;
        },
        getMenu(): Array<SidebarItem | SidebarComponentItem | SidebarHeaderItem> {
            if (this.adminMode) {
                return this.menuAdmin;
            } else {
                return this.menu;
            }
        },
    },
    methods: {
        ...mapActions('sidebar', ['loadMenu', 'setIsOpen']),
        onToggleCollapse(): void {
            this.setIsOpen(!this.isOpen);
            this.$emit('input', this.sidebarOffsetWidth);
        },
    },
});
